import { render, staticRenderFns } from "./NormalSearchNav496.vue?vue&type=template&id=52128cff&scoped=true&"
import script from "./NormalSearchNav496.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav496.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52128cff",
  null
  
)

export default component.exports